module.exports = __webpack_public_path__ + "static/media/2023_25.def87861.jpg";